// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Login_Wrapper__3REWv","Heading":"Login_Heading__3LRMh","Form":"Login_Form__28CAu"};